<template>
    <div class="pratice-explanatory-topics-dom-content" id="identidade-verbal-na-pratica-domingao" data-search-anchor>              

        <div class="pratice-explanatory-topics-dom-wrapper">
            <div class="pratice-explanatory-topics-dom-release-container">
                <p class="pratice-release-paragraph-title">{{ praticeReleaseParagraphTitle }}</p>
                <p class="pratice-release-paragraph">{{ praticeReleaseParagraph1 }}</p>                        
                <p class="pratice-release-paragraph">{{ praticeReleaseParagraph2 }}</p>                
                <p class="pratice-release-paragraph">{{ praticeReleaseParagraph3 }}</p>
                <p class="pratice-release-paragraph">{{ praticeReleaseParagraph4 }}</p>                                         
            </div>

            <div class="pratice-explanatory-topics-dom-tips-container">
                <p class="pratice-explanatory-topics-dom-tips-paragraph-tilte">{{ praticeTipsParagraphTitle }}</p>
                <p class="pratice-tips-explanatory-topics-dom-paragraph">{{ praticeTipsParagraph1 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph2 }}</p>
                <ThreeCircles />
                <p class="pratice-tips-explanatory-topics-dom-paragraph">{{ praticeTipsParagraph3 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph4 }}</p>
                <OneCircle />
                <p class="pratice-tips-explanatory-topics-dom-paragraph">{{ praticeTipsParagraph5 }}</p>
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph6 }}</p>
                <ThreeCircles />

                <div class="pratice-legend-explanatory-topics-dom-wrapper">
                  <div class="pratices-tips-legend-paragraph">
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph7 }}</p>
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph8 }}</p>
                  </div>
                  
                  <div class="pratice-legend-circles">
                    <div class="pratice-line">
                      <LineGradient />
                    </div>
                    <div class="pratice-circles">
                      <ThreeCircles /><TwoCircles /><OneCircle /><BlankCircles />
                    </div>                   
                  </div>                  
                </div>           
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import BlankCircles from '@/assets/icons/BlankCircles.vue'
import LineGradient from '@/assets/icons/LineGradient.vue'
import OneCircle from '@/assets/icons/OneCircle.vue'
import ThreeCircles from '@/assets/icons/ThreeCircles.vue'
import TwoCircles from '@/assets/icons/TwoCircles.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import PraticePageMixin from '@/mixins/pratice-page-mixin'
import { PraticePageStore } from '@/store/verbal-identity-page/pratice-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({components: { ThreeCircles, LineGradient, TwoCircles, OneCircle, BlankCircles }})
export default class PraticeExplanatoryTopicsDomSection extends Mixins(PraticePageMixin) {
  praticePageStore: PageStoreContract = getModule(PraticePageStore, this.$store)

  get praticeReleaseParagraphTitle(): string {
    return this.getElementText(7, 0)
  }

  get praticeReleaseParagraph1(): string {
    return this.getElementText(7, 1)
  }

  get praticeReleaseParagraph2(): string {
    return this.getElementText(7, 2)
  }

  get praticeReleaseParagraph3(): string {
    return this.getElementText(7, 3)
  }

  get praticeReleaseParagraph4(): string {
    return this.getElementText(7, 4)
  }

  get praticeTipsParagraphTitle(): string {
    return this.getElementText(7, 5)
  }

  get praticeTipsParagraph1(): string {
    return this.getElementText(7, 6)
  }

  get praticeTipsParagraph2(): string {
    return this.getElementText(7, 7)
  }

  get praticeTipsParagraph3(): string {
    return this.getElementText(7, 8)
  }

  get praticeTipsParagraph4(): string {
    return this.getElementText(7, 9)
  }

  get praticeTipsParagraph5(): string {
    return this.getElementText(7, 10)
  }

  get praticeTipsParagraph6(): string {
    return this.getElementText(7, 11)
  }

  get praticeTipsParagraph7(): string {
    return this.getElementText(7, 12)
  }

  get praticeTipsParagraph8(): string {
    return this.getElementText(7,  13)
  }

  async getPraticePage(): Promise<void> {
    await this.praticePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.praticePageStore.isLoading) {
      await this.getPraticePage()
    }
  }
}
</script>

<style lang="scss">
.pratice-explanatory-topics-dom-content {
  display: grid;
  justify-content: center; 
  max-width: 1032px;
}

.pratice-explanatory-topics-dom-wrapper {
  position: relative; 
  display: grid;
  grid-template-columns: repeat(2, 495px);
  column-gap: 42px;
  margin-top: 43px;
}

.pratice-explanatory-topics-dom-release-container {
  width: 506px;
  height: 873px;
  border-radius: 16px; 
  color: white;
  background: linear-gradient(90deg, #0079FD -37.91%, #2D51FB 20.11%, #5A29FA 78.13%, #8800F8 137.91%);
  white-space: pre;
}

.pratice-explanatory-topics-dom-tips-container {
  width: 506px;
  height: 873px;    
}

.pratice-release-paragraph {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;  
  margin:0 31px 22px 33px;
}

.pratice-release-paragraph:last-of-type{
  white-space: pre;
}

.pratice-release-paragraph-title {
  font-weight: 700;
  font-size: 20px;  
  line-height: 24px;
  margin:31px 0 35px 29px;
}

.pratice-release-paragraph-title {
  white-space: pre;
}

.pratice-explanatory-topics-dom-tips-paragraph-tilte {
  font-weight: 800;
  font-size: 20px;  
  line-height: 17px;
  margin-top: 31px;
  margin-bottom: 48px;
  white-space: pre; 
  color: rgba(149, 149, 149, 1);
}

.pratice-tips-explanatory-topics-dom-paragraph {
  font-weight: 400;
  font-size: 16px;  
  line-height: 24px;
  margin-bottom: 0; 
  white-space: pre; 
  color: rgba(149, 149, 149, 1);
}

.pratice-tips-explanatory-topics-dom-paragraph:nth-child(5) {
  margin-top: 77px;
}

.pratice-tips-explanatory-topics-dom-paragraph:nth-child(8) {
  margin-top: 100px;
}

.pratice-tips-bold-paragraph{
  font-weight: 800;
  font-size: 16px;  
  line-height: 24px;
  margin: 0;
  color: rgba(149, 149, 149, 1);
}

.pratice-legend-explanatory-topics-dom-wrapper {
  display: flex;
  flex-direction: column;  
  margin-top: 86px;
}

.pratices-tips-legend-paragraph {
  display: flex;
  gap: 118px;              
}

.pratices-legend-paragraph {
  display: flex;
  font-weight: 600;
  font-size: 16px;  
  line-height: 100%;
  margin-top: 0;
  margin-bottom: 7px;
  color: rgba(149, 149, 149, 1);
}

.pratice-legend-circles {
  display: flex;
  flex-direction: column;
  gap: 12px;  
}

.pratice-circles{
  display: flex;
  gap: 74px;
}

</style>
